import { Box, Typography } from "@mui/material";
import { AuthLayout, SignInWrapper } from "../Auth/auth.style";

const SurveyLinkSent = () => {
  return (
    <Box sx={AuthLayout}>
      <Box sx={SignInWrapper}>
        <Typography
          variant="display"
          sx={{ fontWeight: "medium", color: "text.primary" }}
        >
          Survey Link Sent!
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "regular", color: "text.secondary" }}
        >
          We have sent an email to your email address. Please check your email.
        </Typography>
      </Box>
    </Box>
  );
};

export default SurveyLinkSent;
